// extracted by mini-css-extract-plugin
export default {"article":"main_article__2r-d0","articleSmart":"main_articleSmart__dQjSb"};